import { Grid, Paper, Button } from "@material-ui/core"
import MigaPan from '../../app/orussystem/component/MigaPan';
import { SearchBar } from "../../utils/SearchBar";
import { ListUserAuth } from "./components/listUserAuth";
import { panelUsersAuthStyle } from "./panelUsersAuthStyle";
import { useEffect, useState } from "react";
import { ModalTowButton } from "../../utils/modals/modalInfoTowButton";
import { ModalChangeRol } from "./components/modals/modalChangeRol";
import { ModalUserAuth } from "./components/modals/modalUserAuth";
import { ModalHandledMachine } from "./components/modals/modalHandledMachine";


export const PanelUserAuth = () => {

    const clases = panelUsersAuthStyle()
    const [isOpenModal, setisOpenModal] = useState(false)
    const [isEdit, setisEdit] = useState(false)
    const [dataEdit, setdataEdit] = useState([])
    const [email, setEmail] = useState("")
    const [listDate] = useState([])
    const [loading, setLoading] = useState(false)


    // Modal info change rol
    const [isOpenModalChange, setisOpenModalChange] = useState(false)
    const [dateChangeRol, setdateChangeRol] = useState("")
    const [isOpenModalRol, setisOpenModalRol] = useState(false)

    //Modal habilitar inhabilitar
    const [isOpenModalChangeStatus, setisOpenModalChangeStatus] = useState(false)
    const [, setstateUser] = useState("")

    // Modal handled machine
    const [isOpenModalMachine, setisOpenModalMachine] = useState(false)
    const [, setid_change_bascula] = useState("")

    // variables multi select machine
    const [lisMachine] = useState([])
    const [selectMachine, setselectMachine] = useState([])


    // Function to handled machine
    const handleChangeBasculas = (event) => {
        setselectMachine(event.target.value);
    };


    const handledOpenEditModal = (data) => {
        setdataEdit(data)
        setisEdit(true)
        setisOpenModal(true)
    }

    const handledOpenModal = () => {
        setdataEdit([])
        setisEdit(false)
        setisOpenModal(true)
    }




    const init = async () => {
        setLoading(false)
        setEmail("")



    }





    const OpenModalInfoChangeRol = (date) => {
        setisOpenModalChange(true)
        setdateChangeRol(date)
    }

    const openModalRol = () => {
        setisOpenModalChange(false)
        setisOpenModalRol(true)
    }

    const openModalMachine = (row) => {

        setid_change_bascula(row.id)
        setisOpenModalMachine(true)
    }

    const handledOpenModalState = (data) => {
        setstateUser(data)
        setisOpenModalChangeStatus(true)
    }

    const clickAcept = async () => {

        let newList = []

        lisMachine.forEach((item, index) => {
            if (selectMachine.includes(item.name)) {
                newList.push(item.id)
            }
        });

    }




    useEffect(() => {
        const fetchData = async () => {
            init()
        };
        fetchData();
    }, [])



    return (
        <>
            {isOpenModal && <ModalUserAuth
                setopenMondal={setisOpenModal}
                isOpen={isOpenModal}
                isEdit={isEdit}
                data={dataEdit}
                reload={init}

            />}

            {isOpenModalChange && <ModalTowButton
                setopenMondal={setisOpenModalChange}
                isOpen={isOpenModalChange}
                reload={init}
                title={"Señor usuario"}
                Messange={"¿Esta seguro de cambiar el Rol para este usuario?"}
                handledAccept={openModalRol}
            />}

            {isOpenModalRol && <ModalChangeRol
                setopenMondal={setisOpenModalRol}
                isOpen={isOpenModalRol}
                reload={init}
                id={dateChangeRol.id}
            />}

            {isOpenModalChangeStatus && <ModalTowButton
                setopenMondal={setisOpenModalChangeStatus}
                isOpen={isOpenModalChangeStatus}
                reload={init}
                title={"Señor usuario"}
                Messange={"¿Esta seguro de cambiar el estado para este usuario?"}


            />}

            {isOpenModalMachine && <ModalHandledMachine
                setopenMondal={setisOpenModalMachine}
                isOpen={isOpenModalMachine}
                reload={init}
                list={lisMachine}
                handledChange={handleChangeBasculas}
                value={selectMachine}
                clickCheck={clickAcept}

            />}

            <Grid item xs={12} >
                <br></br>
                <br></br>
                <MigaPan
                    namePage="Administracion de Usuarios"
                    to="/"
                    namePage2="Administracion"
                    to2="/administracion"
                >
                    Home
                </MigaPan>
            </Grid>

            <Grid item xs={5}>
                <Button variant="contained" color="primary" onClick={handledOpenModal}>
                    Crear usuario
                </Button>
            </Grid>
            <SearchBar
                reloadTable={init}
                setFilter={setEmail}
                filter={email}

            />
            <Grid item xs={12}>
                <Paper className={clases.paper}>
                    <ListUserAuth
                        rows={listDate}
                        openModalEdit={handledOpenEditModal}
                        classes={clases}
                        totalElement={0}
                        changeRol={OpenModalInfoChangeRol}
                        changeStatus={handledOpenModalState}
                        changeMachine={openModalMachine}
                        isLoanding={loading}
                    />
                </Paper>
            </Grid>
        </>
    )
}